(function () {
  if (window.BoyaVideoPopup && window.BoyaVideoPopup.bound) return;

  function getPopup() {
    var popups = document.querySelectorAll('.video-popup');
    if (!popups.length) return null;

    var popup = popups[0];
    for (var i = 1; i < popups.length; i++) {
      popups[i].parentNode && popups[i].parentNode.removeChild(popups[i]);
    }
    return popup;
  }

  /**
   * Normalize watch / youtu.be / embed URLs to an embed URL with autoplay.
   * Matches original main.js intent (embed src into .video-popup iframe).
   */
  function toEmbedUrl(url) {
    if (!url) return '';
    url = String(url).trim().replace(/&amp;/gi, '&');

    var id = null;
    var m =
      url.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/) ||
      url.match(/[?&]v=([A-Za-z0-9_-]{6,})/) ||
      url.match(/\/embed\/([A-Za-z0-9_-]{6,})/) ||
      url.match(/\/shorts\/([A-Za-z0-9_-]{6,})/);

    if (m) id = m[1];

    if (id) {
      return 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
    }

    if (/youtube\.com|youtu\.be/i.test(url)) {
      return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1&rel=0';
    }

    return url;
  }

  function openPopup(popup, url) {
    if (!popup || !url) return;
    var embed = toEmbedUrl(url);
    if (!embed) return;
    var iframe = popup.querySelector('iframe');
    if (iframe) iframe.setAttribute('src', embed);
    popup.style.display = 'flex';
    popup.hidden = false;
    popup.classList.add('active');
    document.documentElement.classList.add('no-scroll');
  }

  function closePopup(popup) {
    if (!popup) return;
    document.documentElement.classList.remove('no-scroll');
    popup.classList.remove('active');
    popup.style.display = 'none';
    popup.hidden = true;
    var iframe = popup.querySelector('iframe');
    if (iframe) iframe.setAttribute('src', '');
  }

  function init() {
    var popup = getPopup();
    if (!popup || popup.dataset.videoPopupBound === '1') return;
    popup.dataset.videoPopupBound = '1';

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.video-play-btn');
      if (btn) {
        event.preventDefault();
        openPopup(popup, btn.getAttribute('data-youtube') || '');
        return;
      }

      if (!popup.classList.contains('active')) return;
      if (!popup.contains(event.target)) return;
      if (event.target.closest('iframe')) return;

      event.preventDefault();
      closePopup(popup);
    });
  }

  window.BoyaVideoPopup = {
    bound: true,
    init: init,
    open: function (url) {
      openPopup(getPopup(), url);
    },
    close: function () {
      closePopup(getPopup());
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
